import React, {Component} from 'react';

class IconDoorClosed extends Component {
  render() {
    const {color, size} = this.props;
    const h = size === "lg"
      ? 128
      : 48;
    const w = size === "lg"
      ? 128
      : 48;
    return (
      <i className="emoji">
        <svg style={{fill: color}} className="emoji" viewBox="-8 -8 64 64" height={h} width={w}  xmlns="http://www.w3.org/2000/svg">
          <path d="M 10.90625 2 C 10.390625 2.046875 9.996094 2.480469 10 3 L 10 47 C 10 47.550781 10.449219 48 11 48 L 39 48 C 39.550781 48 40 47.550781 40 47 L 40 3 C 40 2.96875 40 2.9375 40 2.90625 C 39.953125 2.390625 39.519531 1.996094 39 2 L 11 2 C 10.96875 2 10.9375 2 10.90625 2 Z M 12 4 L 38 4 L 38 46 L 12 46 Z M 34.5 24 C 33.671875 24 33 24.671875 33 25.5 C 33 26.328125 33.671875 27 34.5 27 C 35.328125 27 36 26.328125 36 25.5 C 36 24.671875 35.328125 24 34.5 24 Z "/>
        </svg>
      </i>
    )
  }
};

export default IconDoorClosed;



// WEBPACK FOOTER //
// ./src/style/icon/IconDoorClosed.js